export const BENEFIT_SECTION_TABS = ["overview", "household", "demographics", "income-eligibility", "program-details", "grants-payments", "history-admin"] as const
export type BenefitSectionTab = typeof BENEFIT_SECTION_TABS[number]
export type BenefitHistoryScope = "all" | "application" | "grants"

/** Shareable filters have one owner: the URL. Missing/ambiguous values use the default. */
export function benefitHistoryScope(params: URLSearchParams): BenefitHistoryScope {
  const values = params.getAll("historyScope")
  return values.length === 1 && (values[0] === "application" || values[0] === "grants") ? values[0] : "all"
}

export function withBenefitHistoryScope(params: URLSearchParams, scope: BenefitHistoryScope): URLSearchParams {
  const next = new URLSearchParams(params)
  if (scope === "all") next.delete("historyScope")
  else next.set("historyScope", scope)
  return next
}

/** Section navigation must not discard the History filter or unrelated route parameters. */
export function withBenefitSection(params: URLSearchParams, section: string): URLSearchParams {
  const next = new URLSearchParams(params)
  next.set("section", benefitSectionTab(section))
  return next
}

// Keep the original income URL valid even though eligibility now belongs with grants.
export const BENEFIT_SECTION_LABELS: Record<BenefitSectionTab, string> = {
  overview: "Overview",
  household: "Household",
  demographics: "Demographics",
  "income-eligibility": "Income",
  "program-details": "Program Details",
  "grants-payments": "Grants/Payments",
  "history-admin": "History/Admin",
}

export function benefitSectionTab(value: string | null): BenefitSectionTab {
  if (value === "income") return "income-eligibility"
  if (value === "eligibility") return "grants-payments"
  return BENEFIT_SECTION_TABS.includes(value as BenefitSectionTab) ? value as BenefitSectionTab : "overview"
}
